webpackJsonp([1],{

/***/ "/hmI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/oBb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _types = __webpack_require__("c97f");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = (0, _defineProperty3.default)({}, types.SEARCHING_CHANGE_KEYWORD, function (state, _ref) {
  var keyword = _ref.keyword;

  state.keyword = keyword;
}); /**
     * Created by jiangzg on 2017/7/18.
     */

exports.default = mutations;

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5reh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//整个页面加载动画
var PAGE_LOADING_QUERY = exports.PAGE_LOADING_QUERY = 'PAGE_LOADING_QUERY';
//vue-router分片加载动画
var PAGE_ROUTER_LOADING = exports.PAGE_ROUTER_LOADING = 'PAGE_ROUTER_LOADING';

/***/ }),

/***/ "75xn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_870ee802_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("ipDe");
function injectStyle (ssrContext) {
  __webpack_require__("/hmI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-870ee802"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_870ee802_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GCuT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _throttle = __webpack_require__("vmIw");

var _throttle2 = _interopRequireDefault(_throttle);

var _debounce = __webpack_require__("eryd");

var _debounce2 = _interopRequireDefault(_debounce);

var _sessionStorage = __webpack_require__("yF0W");

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

var _extend = __webpack_require__("UfKo");

var _extend2 = _interopRequireDefault(_extend);

var _url = __webpack_require__("a0FT");

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  throttle: _throttle2.default,
  debounce: _debounce2.default,
  extend: _extend2.default,
  sessionStorage: _sessionStorage2.default,
  url: _url2.default
};

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _logger = __webpack_require__("sax8");

var _logger2 = _interopRequireDefault(_logger);

var _actions = __webpack_require__("mUbh");

var actions = _interopRequireWildcard(_actions);

var _mutations = __webpack_require__("ukYY");

var _mutations2 = _interopRequireDefault(_mutations);

var _store = __webpack_require__("lFA8");

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (Object({"NODE_ENV":"production"}).vuex !== 'Vuex') {
  _vue2.default.use(_vuex2.default);
}

var initState = {
  //页面加载提示
  show: true,
  'page-router-loading': false
};
var debug = "production" !== 'production';

var store = new _vuex2.default.Store({
  state: initState,
  actions: actions,
  mutations: _mutations2.default,
  modules: {
    search: _store2.default
  },
  strict: debug,
  plugins: debug ? [(0, _logger2.default)()] : []
});

store.registerModule('routerDir', {
  state: {
    direction: 'forward'
  },
  mutations: {
    updateDirection: function updateDirection(state, payload) {
      state.direction = payload.direction;
    }
  },
  actions: {
    updateDirection: function updateDirection(_ref, direction) {
      var commit = _ref.commit;

      commit({ type: 'updateDirection', direction: direction });
      if (direction.direction == 'out') {
        setTimeout(function () {
          commit({ type: 'updateDirection', direction: 'forward' });
        }, 350);
      }
    }
  }
});

exports.default = store;

/***/ }),

/***/ "J51G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadDataLimit_vue__ = __webpack_require__("Qxna");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadDataLimit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadDataLimit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadDataLimit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadDataLimit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae04066_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadDataLimit_vue__ = __webpack_require__("viV/");
function injectStyle (ssrContext) {
  __webpack_require__("LqHr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadDataLimit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae04066_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadDataLimit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LqHr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHdK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "v1.0.0/img/page_loading.80b14bd.svg";

/***/ }),

/***/ "NPsK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchChangeKeyword = undefined;

var _types = __webpack_require__("c97f");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var searchChangeKeyword = exports.searchChangeKeyword = function searchChangeKeyword(_ref, _ref2) {
  var commit = _ref.commit;
  var keyword = _ref2.keyword;

  commit(types.SEARCHING_CHANGE_KEYWORD, {
    keyword: keyword
  });
};

/***/ }),

/***/ "Oj91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftMenu_vue__ = __webpack_require__("ZuaC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftMenu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftMenu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftMenu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dea5753_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leftMenu_vue__ = __webpack_require__("nxnr");
function injectStyle (ssrContext) {
  __webpack_require__("jQWu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftMenu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dea5753_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leftMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "P6Tz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "v1.0.0/img/lazyload_blank.202ac1e.png";

/***/ }),

/***/ "PtPD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],staticClass:"large clear"},[_c('div',{staticClass:"global-padding"},[_c('a',{attrs:{"href":("" + (_vm.item.type==10?'/mb/video/video/':'/mb/article/article/') + (_vm.item.blogid) + ".html")}},[_c('div',{staticClass:"stream-title ft14 mgb12"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('div',{staticClass:"stream-box"},[(_vm.tag || _vm.item.type==9)?[(_vm.item.type==1)?_c('span',{staticClass:"event-tag qingdan"},[_vm._v("清单")]):(_vm.item.type==2)?_c('span',{staticClass:"event-tag xinping"},[_vm._v("新品")]):(_vm.item.type==4)?_c('span',{staticClass:"event-tag tiyan"},[_vm._v("体验")]):(_vm.item.type==10)?_c('span',{staticClass:"event-tag video"},[_vm._v("视频")]):(_vm.item.type==11)?_c('span',{staticClass:"event-tag info"},[_vm._v("资讯")]):(_vm.item.type==9)?_c('span',{staticClass:"event-tag qingtiyan"},[_vm._v("轻体验")]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"stream-img"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(("//s2.jiguo.com/" + (_vm.item.cover) + "/640?imageView2/1/w/640/h/320/q/100")),expression:"`//s2.jiguo.com/${item.cover}/640?imageView2/1/w/640/h/320/q/100`"}],attrs:{"data-background-size":((220/75) + "rem auto"),"src":("//s2.jiguo.com/" + (_vm.item.cover) + "/640?imageView2/1/w/60/h/30/q/30")}}),_vm._v(" "),_c('div',{staticClass:"mask-cover"})]),_vm._v(" "),_c('div',{staticClass:"stream-bottom"},[_c('div',{staticClass:"stream-bottom-inner"},[_c('div',{staticClass:"video"},[(_vm.item.type == 2 && _vm.item.button_link != '')?[_c('img',{staticClass:"vide-img",attrs:{"src":"https://cdn.jiguo.com/app/icon/dy.png"}})]:(_vm.item.video == 1)?[_c('i',{staticClass:"icon icon-video"})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"stream-text"},[(_vm.item.type==1 || _vm.item.type==10)?[(_vm.item.format && _vm.item.format.list_bottom_left && _vm.item.format.list_bottom_left!='')?_c('span',{staticClass:"ft12"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.item.addtime)+" · "+_vm._s(_vm.item.format.list_bottom_left)+"\n\t\t\t\t\t\t\t\t")]):_c('span',{staticClass:"ft12"},[_vm._v(_vm._s(_vm.item.addtime))])]:_vm._e(),_vm._v(" "),(_vm.item.type==2||_vm.item.type==3 || _vm.item.type==11)?[_c('span',{staticClass:"ft12"},[_vm._v(_vm._s(_vm.item.addtime))])]:(_vm.item.type==4)?_c('span',{staticClass:"ft12 user-face-warp"},[_c('span',{staticClass:"ft12"},[_vm._v(_vm._s(_vm.item.author)+" · "+_vm._s(_vm.item.addtime))])]):_vm._e(),_vm._v(" "),(!_vm.vip)?_c('div',{staticClass:"ft12 praise-replay"},[_c('span',{staticClass:"pos-rel"},[_c('i',{staticClass:"icon icon-praise"}),_vm._v(_vm._s(_vm.item.praise))]),_vm._v(" "),_c('span',{staticClass:"pos-rel mgl10"},[_c('i',{staticClass:"icon icon-replay"}),_vm._v(_vm._s(_vm.item.reply))])]):_c('div',{staticClass:"ft12 praise-replay"},[_c('span',{staticClass:"pos-rel"},[_vm._v(_vm._s(_vm.item.read_num))]),_vm._v(" "),_c('span',{staticClass:"pos-rel mgl10"},[_vm._v("浏览")])])],2)])])],2)]),_vm._v(" "),(_vm.productName)?[(_vm.item.product)?_c('div',{staticClass:"article-show-all-header"},[_c('a',{staticClass:"article-show-all-header-href ft12 gray",attrs:{"href":("/mb/article/articlelist/id/" + (_vm.item.pid) + ".html")}},[_c('span',{staticClass:"line1"},[_vm._v(_vm._s(_vm.item.product))]),_vm._v(" "),(_vm.item.num>1)?_c('span',{staticClass:"icon icon-more"},[_vm._v(_vm._s(_vm.item.num)+"篇")]):_vm._e()])]):_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QSyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]}),_vm._v(" "),_c('page-header',{attrs:{"curr":"info"}}),_vm._v(" "),_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"mian-stream"},[_c('load-data-limit',{attrs:{"url":"/api/article/GetArticleList","cache":_vm.listcache,"extData":_vm.extData},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('larg-card',{attrs:{"item":props.item,"tag":false}})]}}])})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qxna":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__("7t+N");

var _jquery2 = _interopRequireDefault(_jquery);

var _throttle = __webpack_require__("vmIw");

var _throttle2 = _interopRequireDefault(_throttle);

var _sessionStorage = __webpack_require__("yF0W");

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

var _types = __webpack_require__("5reh");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: {
    cache: {
      type: Boolean,
      default:  true ? true : false
    },
    url: {
      type: String
    },
    size: {
      type: Number,
      default: 10
    },
    fixload: {
      type: Number,
      default: 1000
    },
    limit: {
      type: [String, Number],
      default: ''
    },
    extData: {
      type: Object,
      default: function _default() {
        return {
          sys: 'mb'
        };
      }
    },
    resultCallback: {
      type: Function,
      default: function _default(replayData) {
        return replayData;
      }
    }
  },
  data: function data() {
    return {
      new_limit: this.limit,
      item_data: [],

      loading: false,
      nodata: false,
      nomore: false,

      timer: null,
      jqueryLoader: null,
      _cacheKey_: window.location.href,
      _cacheData_: ''
    };
  },
  components: {},
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      var _this = this;

      this._cacheKey_ = window.location.href + (this.extData.blog_type || '');
      var cache_data = _sessionStorage2.default.get(this._cacheKey_);
      if (!this.cache || !cache_data) {
        _sessionStorage2.default.delete(this._cacheKey_);
        this.getItemData();
      } else {
        this._cacheData_ = cache_data;
        this.new_limit = cache_data.limit || this.new_limit;
        this.item_data = cache_data.data || this.item_data;
        this.loading = cache_data.loading || this.loading;
        this.nodata = cache_data.nodata || this.nodata;
        this.nomore = cache_data.nomore || this.nomore;
        this.$store.commit(types.PAGE_LOADING_QUERY, {
          show: false
        });
      }

      var throttleDeFn = (0, _throttle2.default)(function () {
        _this.getItemData();
      }, 320);
      (0, _jquery2.default)(window).off('scroll.home').on('scroll.home', function () {
        throttleDeFn();
      });
    },
    getItemData: function getItemData() {
      var _this2 = this;

      //没有更多数据
      if (this.nomore) return;

      //正在加载中
      if (this.loading) return;

      var loadMoreObj = (0, _jquery2.default)(this.$refs['loading-more-flage'] || null);
      if (loadMoreObj.length && window.$WIN_HEIGHT + (0, _jquery2.default)(window).scrollTop() + loadMoreObj.height() + this.fixload < loadMoreObj.offset().top) {
        return;
      }
      this.loading = true;
      var l_timer = setTimeout(function () {
        _this2.loading = false;
        _this2.jqueryLoader && _this2.jqueryLoader.abort();
      }, 10000);

      this.jqueryLoader = _jquery2.default.get(this.url, _jquery2.default.extend(true, this.extData, {
        limit: this.new_limit,
        size: this.size
      }), function (replayDate) {
        replayDate = _this2.resultCallback(replayDate);

        _this2.loading = false;
        clearTimeout(l_timer);

        if (replayDate.resultCode == 0) {

          replayDate.result = replayDate.result || [];
          //没有数据
          if (!_this2.item_data.length && !replayDate.result.length) {
            _this2.nodata = true;
          }
          if (replayDate.result.length < _this2.size) {
            _this2.nomore = true;
          }

          _this2.new_limit = replayDate.limit;
          _this2.item_data = _this2.item_data.concat(replayDate.result);

          //缓存数据
          _this2._cacheData_ = {
            limit: _this2.new_limit,
            data: _this2.item_data,
            loading: _this2.loading,
            nodata: _this2.nodata,
            nomore: _this2.nomore
          };
          _sessionStorage2.default.set(_this2._cacheKey_, _this2._cacheData_);
          (0, _jquery2.default)(window).trigger('scroll');

          if (!_this2.nomore && !_this2.nodata) {
            if (loadMoreObj.length && window.$WIN_HEIGHT + (0, _jquery2.default)(window).scrollTop() + loadMoreObj.height() >= loadMoreObj.offset().top) {
              _this2.timer && clearTimeout(_this2.timer);
              _this2.timer = setTimeout(function () {
                _this2.getItemData();
              }, 0);
            }
          }
          _this2.$store.commit(types.PAGE_LOADING_QUERY, {
            show: false
          });
        } else {}
      }, 'json');
    },
    refresh: function refresh(isClearCache) {
      this.jqueryLoader && this.jqueryLoader.abort();
      !isClearCache && _sessionStorage2.default.delete(this._cacheKey_);
      this.timer && clearTimeout(this.timer);
      this.new_limit = '';
      this.item_data = [];
      this.nomore = false;
      this.loading = false;
      this.nodata = false;
      !isClearCache && (this._cacheData_ = '');
    }
  },
  watch: {
    extData: {
      deep: true,
      handler: function handler(newVal, oldVal) {
        var _this3 = this;

        this.refresh(true);
        this.$nextTick(function () {
          _this3.initData();
        });
      }
    }
  }
};

/***/ }),

/***/ "UfKo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function extend(target) {
  var sources = Array.prototype.slice.call(arguments, 1);

  for (var i = 0; i < sources.length; i += 1) {
    var source = sources[i];
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

module.exports = extend;

/***/ }),

/***/ "V6Xr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("qvIE");

var _waves = __webpack_require__("xKgX");

var _waves2 = _interopRequireDefault(_waves);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { name: 'waves' };

    var _installObj = {
      inserted: function inserted(el, binding) {
        if (binding.value || binding.value === undefined) {
          var classes = ['button', 'circle', 'block', 'float', 'light', 'classic'].filter(function (cls) {
            return binding.modifiers[cls];
          }).map(function (cls) {
            return 'waves-' + cls;
          });
          if (classes.length) {
            _waves2.default.attach(el, classes);
          } else {
            _waves2.default.attach(el);
          }
        }
      },
      update: function update(el, binding) {
        _installObj.inserted.apply(_installObj, arguments);
      }
    };
    Vue.directive(options.name, _installObj);
    Vue.mixin({
      created: function created() {
        _waves2.default.init(options);
      }
    });
  }
};

/***/ }),

/***/ "VqiI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__("Cz8s");

var _header2 = _interopRequireDefault(_header);

var _loadDataLimit = __webpack_require__("J51G");

var _loadDataLimit2 = _interopRequireDefault(_loadDataLimit);

var _large = __webpack_require__("flFi");

var _large2 = _interopRequireDefault(_large);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      listcache:  true ? true : false,
      extData: {
        type: 11
      }
    };
  },
  components: {
    PageHeader: _header2.default,
    LargCard: _large2.default,
    loadDataLimit: _loadDataLimit2.default
  },
  computed: {
    show: function show() {
      return this.$store.state.show;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Wa8X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZuaC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__("7t+N");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		show: {
			type: Boolean,
			default: false
		},
		curr: {
			type: String,
			default: 'index'
		}
	},
	data: function data() {
		return {
			startX: 0,
			endX: 0,
			move: '100%'
		};
	},

	methods: {
		closeMenu: function closeMenu() {
			this.$emit('closeMenu');
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "a0FT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getUrlParams: function getUrlParams(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var search = window.location.href.split('?')[1];
    if (search) {
      var r = search.match(reg);
      if (r != null) return unescape(r[2]);
    }
    return null;
  }
};

/***/ }),

/***/ "baTq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "v1.0.0/img/nodata.206b0d9.png";

/***/ }),

/***/ "c97f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 关键词变化
var SEARCHING_CHANGE_KEYWORD = exports.SEARCHING_CHANGE_KEYWORD = 'SEARCHING_CHANGE_KEYWORD';

/***/ }),

/***/ "e5RB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _loading = __webpack_require__("qqiS");

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loading = {
	install: function install(Vue) {
		Vue.component('loading', _loading2.default);
	}
};

exports.default = loading;

/***/ }),

/***/ "edbi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eryd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear'
 * that is a function which will clear the timer to prevent previously scheduled executions.
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function debounced() {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  debounced.flush = function () {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;

      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

module.exports = debounce;

/***/ }),

/***/ "flFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_vue__ = __webpack_require__("kIML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b42f628_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_vue__ = __webpack_require__("PtPD");
function injectStyle (ssrContext) {
  __webpack_require__("edbi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b42f628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b42f628_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i5jt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "v1.0.0/img/app-menue-icon.6dfff9a.png";

/***/ }),

/***/ "iCER":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "v1.0.0/img/logo.f321fdc.png";

/***/ }),

/***/ "icb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("VqiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68614886_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("QSyW");
function injectStyle (ssrContext) {
  __webpack_require__("75xn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68614886_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ipDe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header header-wrap"},[_c('div',{staticClass:"header header-inner"},[_c('div',{staticClass:"menu"},[_c('a',{staticClass:"menu__open",on:{"click":_vm.openMenu}},[_c('i',{directives:[{name:"waves",rawName:"v-waves.circle",value:(true),expression:"true",modifiers:{"circle":true}}],staticClass:"icon icon-menu"})]),_vm._v(" "),_c('left-menu',{ref:"menu",attrs:{"show":_vm.show,"curr":_vm.curr},on:{"closeMenu":_vm.closeMenu}})],1),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":"/"},on:{"click":_vm.clearCacheData}},[_c('img',{attrs:{"src":__webpack_require__("iCER")}})])]),_vm._v(" "),_c('div',{staticClass:"header-right"},[(_vm.search)?[_c('a',{staticClass:"search",attrs:{"href":"/mb/search/list.html"},on:{"click":_vm.searchRecodCurrUrl}},[_c('i',{directives:[{name:"waves",rawName:"v-waves.circle",value:(true),expression:"true",modifiers:{"circle":true}}],staticClass:"icon icon-search"})])]:_vm._e(),_vm._v(" "),(_vm.user)?[(_vm.window.URL && _vm.window.URL['login'])?_c('a',{staticClass:"user has-login",attrs:{"href":"/mb/user/index.html"}},[_c('div',{staticClass:"header-right-badge-wrap"},[_c('div',{directives:[{name:"waves",rawName:"v-waves.circle",value:(true),expression:"true",modifiers:{"circle":true}}],staticClass:"user-innner"},[_c('img',{attrs:{"src":_vm.window.URL['user-face']}})]),_vm._v(" "),(_vm.hasMessage)?_c('em',{staticClass:"badge",class:{'number':_vm.ioMessageNumber}},[_vm._v(_vm._s(_vm.ioMessageNumber ? _vm.ioMessageNumber : ''))]):_vm._e()])]):_c('a',{staticClass:"user fl pos-rel",attrs:{"href":"/mb/user/index.html"}},[_c('i',{staticClass:"icon icon-user"})])]:_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jQWu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kIML":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: {
    item: {
      type: Object
    },
    tag: {
      type: Boolean,
      default: true
    },
    productName: {
      type: Boolean,
      default: false
    },
    vip: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ "lFA8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__("NPsK");

var actions = _interopRequireWildcard(_actions);

var _mutations = __webpack_require__("/oBb");

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var state = {
  //请求地址
  //search_url: '',
  //搜索关键词
  keyword: ''
  //搜索状态
  //searching: false,
  //首页搜索结果
  //result: {},
  //试用
  //event: [],
  //文章
  //blog: []
};

exports.default = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: _mutations2.default
};

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerLoading = exports.hidePageLoading = exports.showPageLoading = undefined;

var _types = __webpack_require__("5reh");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var showPageLoading = exports.showPageLoading = function showPageLoading(_ref) {
  var commit = _ref.commit;

  commit(types.PAGE_LOADING_QUERY, {
    show: true
  });
};

var hidePageLoading = exports.hidePageLoading = function hidePageLoading(_ref2) {
  var commit = _ref2.commit;

  commit(types.PAGE_LOADING_QUERY, {
    show: false
  });
};

var routerLoading = exports.routerLoading = function routerLoading(_ref3, val) {
  var commit = _ref3.commit;

  commit(types.PAGE_ROUTER_LOADING, val);
};

/***/ }),

/***/ "nxnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"side-menu",class:{show: _vm.show},attrs:{"id":"side-menu"}},[_c('div',{staticClass:"mask",on:{"click":_vm.closeMenu}}),_vm._v(" "),_c('menu',{ref:"menu",staticClass:"menu-inner"},[_c('div',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],staticClass:"menu-app-download clear"},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"swipe"},[_c('ul',[_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='index'}},[_vm._m(1)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='event'}},[_vm._m(2)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='product'}},[_vm._m(3)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='rebate'}},[_vm._m(4)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='video'}},[_vm._m(5)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='article'}},[_vm._m(6)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='vip'}},[_vm._m(7)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='youpin'}},[_vm._m(8)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='mall'}},[_vm._m(9)]),_vm._v(" "),_c('li',{directives:[{name:"waves",rawName:"v-waves.block",value:(true),expression:"true",modifiers:{"block":true}}],class:{'on': _vm.curr=='html'}},[_vm._m(10)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"block",attrs:{"href":"/mb/app/index.html"}},[_c('div',{staticClass:"app-download-logo fl"},[_c('img',{attrs:{"src":__webpack_require__("i5jt")}})]),_vm._v(" "),_c('div',{staticClass:"app-download-desc"},[_c('div',{staticClass:"ft14"},[_vm._v("下载")]),_vm._v(" "),_c('div',{staticClass:"ft16 red"},[_vm._v("极果APP")])]),_vm._v(" "),_c('div',{staticClass:"icon icon-app-down-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/index/index.html"}},[_c('i',{staticClass:"icon icon-home"}),_vm._v("首页")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/event/index.html"}},[_c('i',{staticClass:"icon icon-menu-event"}),_vm._v("试用")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/product/index.html"}},[_c('i',{staticClass:"icon icon-xinping"}),_vm._v("新品")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/rebate/index.html"}},[_c('i',{staticClass:"icon icon-discount"}),_vm._v("折扣")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/video/index.html"}},[_c('i',{staticClass:"icon icon-videos"}),_vm._v("视频")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/article/index.html"}},[_c('i',{staticClass:"icon icon-experience"}),_vm._v("体验")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/vip/index.html"}},[_c('i',{staticClass:"icon icon-uee"}),_vm._v("体验师")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/html/youpin.html"}},[_c('i',{staticClass:"icon icon-youpin"}),_vm._v("优品")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/mall/index.html"}},[_c('i',{staticClass:"icon icon-mall"}),_vm._v("商城")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/mb/html/list.html"}},[_c('i',{staticClass:"icon icon-contact"}),_vm._v("联系")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qqiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf459c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("u/0v");
function injectStyle (ssrContext) {
  __webpack_require__("Wa8X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf459c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qvIE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tkOC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "v1.0.0/img/lazyload_default.912f788.png";

/***/ }),

/***/ "u/0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loading"},[_c('img',{staticClass:"page-loading-img",attrs:{"src":__webpack_require__("NHdK")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ukYY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations; /**
                 * Created by jiangzg on 2017/7/18.
                 */

var _types = __webpack_require__("5reh");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.PAGE_LOADING_QUERY, function (state, _ref) {
  var show = _ref.show;

  state.show = show;
}), (0, _defineProperty3.default)(_mutations, types.PAGE_ROUTER_LOADING, function (state, val) {
  state['page-router-loading'] = val;
}), _mutations);
exports.default = mutations;

/***/ }),

/***/ "vPmW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _app = __webpack_require__("icb2");

var _app2 = _interopRequireDefault(_app);

var _loading = __webpack_require__("e5RB");

var _loading2 = _interopRequireDefault(_loading);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _jquery = __webpack_require__("7t+N");

var _jquery2 = _interopRequireDefault(_jquery);

var _waves = __webpack_require__("V6Xr");

var _waves2 = _interopRequireDefault(_waves);

var _index = __webpack_require__("xHMi");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_waves2.default);

_vue2.default.use(_index2.default);

window.$WIN_HEIGHT = (0, _jquery2.default)(window).height();
window.$WIN_WIDTH = (0, _jquery2.default)(window).width();

_vue2.default.use(_loading2.default);

new _vue2.default({
  el: '#app',
  store: _store2.default,
  render: function render(_) {
    return _(_app2.default);
  }
});

/***/ }),

/***/ "viV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mian-content"},[_c('div',{staticClass:"mian-stream-box"},[_c('ul',{staticClass:"mian-stream-inner"},[_vm._l((_vm.item_data),function(v){return [_vm._t("item",null,{"item":v})]})],2)]),_vm._v(" "),_c('div',{ref:"loading-more-flage",staticClass:"loading-more-flage bg-white"},[_vm._t("load",function(){return [(_vm.loading)?_c('div',{staticClass:"main loading-more bg-white"},[_vm._m(0)]):_c('div',{staticClass:"ft14 gray tc"},[(_vm.nodata)?_c('div',{staticClass:"main first-no-data bg-white pdt15 pdb15"},[_vm._m(1)]):(_vm.nomore)?_c('div',{staticClass:"main no-data bg-white pdt15 pdb15"},[_c('div',[_vm._v("没有更多啦~")])]):_c('div',{ref:"load-more",staticClass:"main no-more bg-white pdt15 pdb15",on:{"click":_vm.getItemData}},[_c('div',[_vm._v("点击加载更多~")])])])]},{"loadingStatus":{loading:_vm.loading,nodata:_vm.nodata,nomore:_vm.nomore}})],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"rect1"}),_vm._v(" "),_c('div',{staticClass:"rect2"}),_vm._v(" "),_c('div',{staticClass:"rect3"}),_vm._v(" "),_c('div',{staticClass:"rect4"}),_vm._v(" "),_c('div',{staticClass:"rect5"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata-center"},[_c('img',{staticClass:"nodata-img",attrs:{"src":__webpack_require__("baTq")}}),_vm._v(" "),_c('div',[_vm._v("暂时没有数据")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vmIw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function throttle(func, wait) {
  var ctx, args, rtn, timeoutID; // caching
  var last = 0;
  wait = wait || 120;

  return function throttled() {
    ctx = this;
    args = arguments;
    var delta = new Date() - last;
    if (!timeoutID) if (delta >= wait) call();else timeoutID = setTimeout(call, wait - delta);
    return rtn;
  };

  function call() {
    timeoutID = 0;
    last = +new Date();
    rtn = func.apply(ctx, args);
    ctx = null;
    args = null;
  }
}

module.exports = throttle;

/***/ }),

/***/ "wqBJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _leftMenu = __webpack_require__("Oj91");

var _leftMenu2 = _interopRequireDefault(_leftMenu);

var _sessionStorage = __webpack_require__("yF0W");

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _socket = __webpack_require__("DmT9");

var _socket2 = _interopRequireDefault(_socket);

var _jquery = __webpack_require__("7t+N");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    curr: {
      type: String,
      default: 'index'
    },
    search: {
      type: Boolean,
      default: true
    },
    user: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false,
      window: window,
      hasMessage: false,
      ioMessageNumber: 0
    };
  },
  components: {
    'left-menu': _leftMenu2.default
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!('messageIo' in window) && window.URL && window.URL['uid'] && window.URL['ioid']) {
      window.messageIo = true;
      setTimeout(function () {
        _this2.pushNotification(window.URL['ioid']);
      });
    }
  },
  methods: {
    openMenu: function openMenu() {
      var _this = this;
      _this.$refs['menu'].$el.style.display = 'block';
      setTimeout(function () {
        _this.show = true;
      }, 0);
    },
    closeMenu: function closeMenu() {
      var _this = this;
      _this.show = false;
      setTimeout(function () {
        _this.$refs['menu'].$el.style.display = 'none';
      }, 320);
    },
    clearCacheData: function clearCacheData() {
      _sessionStorage2.default.clear();
    },
    searchRecodCurrUrl: function searchRecodCurrUrl() {
      _jsCookie2.default.set('isSearchCurrUrl', window.location.href, { path: '/' });
    },
    pushNotification: function pushNotification(userssid) {
      var _this3 = this;

      var socket;
      // 连接服务端
      if (true) {
        socket = (0, _socket2.default)('wss://io.jiguo.com');
      } else {
        socket = (0, _socket2.default)('ws://msg.jiguo.com:2126');
      }
      // 连接后登录
      socket.on('connect', function () {
        socket.emit('login', userssid);
      });
      // 后端推送来消息时
      socket.on('h5-news', function (msg) {
        eval('msg = ' + msg);

        if (msg != null) {
          if (msg.type == 'news') {
            //消息
            if (typeof msg.num != 'undefined' && parseInt(msg.num) > 0) {
              // 显示数字
              _this3.hasMessage = true;
              _this3.ioMessageNumber = msg.num;
            } else if (parseInt(msg.num) == 0 && typeof msg.tips != 'undefined' && parseInt(msg.tips) > 0) {
              // 显示点
              _this3.hasMessage = true;
              _this3.ioMessageNumber = 0;
            } else {
              _this3.hasMessage = false;
              _this3.ioMessageNumber = 0;
            }
          } else if (msg.type == 'broadcast') {

            _this3.hasMessage = !!msg.tips;
            _this3.ioMessageNumber = msg.tips || 0;
          }
        }
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "xHMi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lazyload_default = __webpack_require__("tkOC");

var _lazyload_default2 = _interopRequireDefault(_lazyload_default);

var _lazyload_blank = __webpack_require__("P6Tz");

var _lazyload_blank2 = _interopRequireDefault(_lazyload_blank);

var _jquery = __webpack_require__("7t+N");

var _jquery2 = _interopRequireDefault(_jquery);

var _index = __webpack_require__("GCuT");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalLazyImgBox = [];
var tempKey = 'id-' + String(Math.random()).replace('.', '');
var windowScrollTop = (0, _jquery2.default)(window).scrollTop();
var windowHeight = (0, _jquery2.default)(window).height();

var loadimg = function loadimg(el, array, callback, cell) {
	if (cell.loading) return;
	var level = 0;
	cell.loading = true;
	array.forEach(function () {
		return function (item) {
			var img = new Image();
			img.onload = function () {
				if (item.level >= level) {
					level = item.level;
					callback.call(el, item.src);
					el.style.background = '';
				}
				if (item.level > 2) {
					cell.loading = false;
				}
				img.onload = null;
			};
			img.onerror = function () {
				if (level <= 0 && cell.times < 3) {
					el.src = _lazyload_blank2.default;
					el.style.background = '#f5f5f5 url(' + _lazyload_default2.default + ') no-repeat center center';
					var size = el.getAttribute('data-background-size');
					if (size) {
						el.style.backgroundSize = size;
					}
					globalLazyImgBox.push(cell);
				}
				cell.loading = false;
				cell.times = (cell.times || 0) + 1;
				img.onerror = null;
			};
			img.src = item.src;
		};
	}());
};

exports.default = {
	install: function install(Vue) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { name: 'lazy' };

		var windowScrollFunctionInit1 = _index2.default.debounce(function () {
			globalLazyImgBox = globalLazyImgBox.map(function (item) {
				item.offset = (0, _jquery2.default)(item.el).offset();
				item.height = (0, _jquery2.default)(item.el).height();
				return item;
			});
		}, 80, true);
		var windowScrollFunctionInit2 = _index2.default.debounce(function () {
			globalLazyImgBox = globalLazyImgBox.map(function (item) {
				item.offset = (0, _jquery2.default)(item.el).offset();
				item.height = (0, _jquery2.default)(item.el).height();
				return item;
			});
		}, 80, false);

		var windowScrollFunction = _index2.default.throttle(function () {
			windowScrollTop = (0, _jquery2.default)(window).scrollTop();
			globalLazyImgBox = globalLazyImgBox.map(function (item) {
				if (!item.offset) item.offset = (0, _jquery2.default)(item.el).offset();
				if (!item.height) item.height = (0, _jquery2.default)(item.el).height();
				return item;
			});
			globalLazyImgBox = globalLazyImgBox.filter(function (item) {
				if (!item.offset || 2 * windowHeight + windowScrollTop > item.offset.top && windowScrollTop - windowHeight / 5 < item.offset.top + item.height) {
					var imgArray = [];
					if (item.src) {
						imgArray.push({
							src: item.src,
							level: 1
						});
					}
					imgArray.push({
						src: item.binding.value,
						level: 2
					});
					loadimg(item.el, imgArray, function (src) {
						this.src = src;
					}, item);
					return false;
				}
				return true;
			});
		}, 320);

		(0, _jquery2.default)(window).on('scroll.lazy', function () {
			windowScrollFunctionInit1();
			windowScrollFunctionInit2();
			windowScrollFunction();
		});

		Vue.directive(options.name, {
			bind: function bind(el, binding) {
				if (binding.value) {
					el.setAttribute(tempKey, el.src);
					el.src = _lazyload_blank2.default;
					var size = el.getAttribute('data-background-size');
					el.style.background = '#f5f5f5 url(' + _lazyload_default2.default + ') no-repeat center center ';
					if (size) {
						el.style.backgroundSize = size;
					}
				}
			},
			inserted: function inserted(el, binding) {
				binding.value && globalLazyImgBox.push({
					src: el.getAttribute(tempKey),
					el: el,
					binding: binding
				});
				(0, _jquery2.default)(window).trigger('scroll.lazy');
			},
			update: function update(el, binding) {
				//console.log('update')
				globalLazyImgBox = globalLazyImgBox.map(function (item) {
					if (item.el == el) {
						item.binding = binding;
					}
					return item;
				});
			},
			componentUpdated: function componentUpdated(el, binding) {
				//console.log('componentUpdated')
				globalLazyImgBox = globalLazyImgBox.map(function (item) {
					if (item.el == el) {
						item.binding = binding;
					}
					return item;
				});
				(0, _jquery2.default)(window).trigger('scroll.lazy');
			},
			unbind: function unbind(el) {
				globalLazyImgBox = globalLazyImgBox.filter(function (item) {
					return item.el != el;
				});
			}
		});
	}
};

/***/ }),

/***/ "yF0W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _md = __webpack_require__("L6bb");

var _md2 = _interopRequireDefault(_md);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = {
  set: function set(key, data) {
    var cache_data = (0, _stringify2.default)([data || '']);
    return sessionStorage.setItem((0, _md2.default)(key), cache_data);
  },
  get: function get(key) {
    var cache_data = sessionStorage.getItem((0, _md2.default)(key));
    if (!cache_data) return '';
    try {
      cache_data = JSON.parse(cache_data);
    } catch (e) {
      cache_data = [''];
    }
    return cache_data[0];
  },
  delete: function _delete(key) {
    sessionStorage.removeItem((0, _md2.default)(key));
  },
  clear: function clear(key) {
    if (key) {
      this.delete(key);
    } else {
      sessionStorage.clear();
    }
  }
}; /**
    +----------------------------------------------------------
    //数据缓存器
    +----------------------------------------------------------
    */

exports.default = cache;

/***/ })

},["vPmW"]);


// WEBPACK FOOTER //
// v1.0.0/js/info.25ce3d7db1f2fdf227ec.js